import * as React from "react";
const SvgYoutube = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.083 7.7c.586.158 1.046.62 1.202 1.204.283 1.062.283 3.28.283 3.28s0 2.216-.283 3.278a1.71 1.71 0 0 1-1.202 1.205c-1.059.284-5.309.284-5.309.284s-4.247 0-5.309-.284a1.71 1.71 0 0 1-1.201-1.205c-.284-1.062-.284-3.279-.284-3.279s0-2.217.284-3.279A1.71 1.71 0 0 1 6.465 7.7c1.062-.284 5.31-.284 5.31-.284s4.249 0 5.308.284m-3.136 4.483-3.53 2.044v-4.088z",
    clipRule: "evenodd"
  }
));
export default SvgYoutube;
